import {FieldResult} from "../../model/api/field-result";
import {FieldRecord} from "../../model/api/field-record";
import {MessageService} from "primeng/api";
import {TranslateService} from "@ngx-translate/core";
import {BehaviorSubject, Observable} from "rxjs";
import {ProgressTracker} from "../../model/api/progress-tracker";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class FieldsService {

  constructor(
    private messageService: MessageService,
    private translateService: TranslateService) {
  }

  public getFields(fieldResult: FieldResult<any>): FieldRecord<any>[] {
    if (fieldResult.success) {
      return fieldResult.records ? fieldResult.records : [];
    } else if (fieldResult.message) {
      this.messageService.add({
        severity: 'error',
        summary: this.translateService.instant('common.message.error', undefined),
        detail: fieldResult.message
      });
      return [];
    }
    return [];
  }

  public createTracker(): ProgressTracker {
    let total = 0;
    let done = 0;
    const progressSubject = new BehaviorSubject<number>(0);

    const updateProgress = () => {
      if (total === 0) {
        progressSubject.next(0);
      } else {
        const value = (done / total) * 100;
        progressSubject.next(Math.min(value, 100));
      }
    };

    return {
      get total() {
        return total;
      },
      get done() {
        return done;
      },
      progress: progressSubject.asObservable(),
      incrementTotal: () => {
        total++;
        updateProgress();
      },
      incrementDone: () => {
        done++;
        updateProgress();
      },
      reset: () => {
        total = 0;
        done = 0;
        updateProgress();
      }
    };
  }

  public loadField<T>(
    records: FieldRecord<any>[],
    fetchFn: () => Observable<FieldResult<T>>,
    tracker: any=this.createTracker(),
    onLoaded?: (records: FieldRecord<any>[]) => void
  ): void {
    if (!records) alert("field records not initiated");
    tracker.incrementTotal();

    fetchFn().subscribe({
      next: fieldResult => {
        const newRecords = fieldResult.records ? this.getFields(fieldResult) : [];
        records.splice(0);
        records.push(...newRecords);
        if (onLoaded) {
          onLoaded(records);
        }
        tracker.incrementDone();
      },
      error: _err => {
        tracker.incrementDone();
      }
    });
  }

  public getDistinctOpts(options: FieldRecord<any>[]): FieldRecord<any>[] {
    if (options) {
      const addedTexts = [];
      return options.filter(option => {
        if (addedTexts.includes(option.text)) false;
        else {
          addedTexts.push(option.text);
          return true;
        }
      });
    }
    return options;
  }
}
